import { FingerPrintIcon, UserPlusIcon } from '@heroicons/react/24/solid'
import React from 'react'
import { NavLink } from 'react-router-dom'

const HostMenu = () => {
  return (
    <>
        
    </>
  )
}

export default HostMenu
